module.exports = __webpack_public_path__ + "static/media/Timetable 3up 2 columns.002 (1).5321dafb.jpeg";